import { Component } from '@angular/core';
import { ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { QRServices } from '../../services/qrServices';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { CustomersServices } from '../../customers/services';
import { ConfigurationServices } from '../../configuration/services';
import { HomeUserBlock } from './home-user-block/home-user-block';
import { ConfigurationPuduRobotsPage } from '../../configuration/configuration-pudu-robots/configuration-pudu-robots';
import { TicketsListArrosseriaPage } from '../../custom/tickets-list-arrosseria/tickets-list-arrosseria';
import { CustomServices } from '../../custom/services';
import { ComponentsPopupsInviteFormModalComponent } from '../../../components/components-popups-invite-form-modal/components-popups-invite-form-modal';

/**
 * Generated class for the HomeDashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard',
  templateUrl: 'home-dashboard.html',
})
export class HomeDashboardPage {

  qr_image = "./assets/images/qr_def.jpg";
  group_id: string = '';
  robots: any = [];
  arrosseria_tickets: any = [];
  invite = {
    restaurantName: '',
    responsibleName: '',
    contact: ''
  };
  showInviteForm = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public qrServices: QRServices,
    public translate: TranslateService,
    public http: HttpClient,
    public customersServices: CustomersServices,
    public configurationServices: ConfigurationServices,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public customServices: CustomServices) {

    if (this.globals.user_disable) {
      this.navCtrl.push(HomeUserBlock);
    }

    this.getWeather();
    if (this.globals.restaurant.pudu_robots_integration) {
      this.puduGetDevices();
      this.puduGetRobotsInfo();
    }
  }

  getWeather() {
    this.globals.weather = null;
    if (this.globals.restaurant.lat && this.globals.restaurant.lng) {
      this.globals.getWeatherForecast();
    }
  }

  fontStyleColor(value) {
    if (value) {
      let cssClasses = {
        'mdi mdi-check': true,
        'font-color-no-addon': false,
        'font-color-addon': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'mdi mdi-check': true,
        'font-color-no-addon': false,
        'font-color-addon': true,
      }
      return cssClasses;
    }
  }

  generateQR() {
    this.qrServices.generateMenuCartaListQr();
  }

  // #region extern open

  openCloseCashBlog() {
    var blog_url = 'https://www.mycheftool.com/post/novedades-version-31095';
    if (this.globals.so_mobile) {
      window.location.assign(blog_url);
    } else {
      window.open(blog_url, '_blank');
    }
  }

  openLink() {
    if (this.globals.so_mobile) {
      window.location.assign('https://printerservices.mycheftool.com/');
    } else {
      window.open('https://printerservices.mycheftool.com/', '_blank');
    }
  }

  openApp(app) {
    switch (app) {
      case 'all':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLinkApp('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
        } else {
          this.openLinkApp('https://play.google.com/store/apps/developer?id=MyChefTool');
        }
        break;
      case 'print':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLinkApp('https://apps.apple.com/es/app/mct-print/id1624692351');
        } else {
          this.openLinkApp('https://play.google.com/store/apps/details?id=com.mycheftool.printer');
        }
        break;
      case 'kds':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLinkApp('https://apps.apple.com/es/app/mct-kitchen-display-system/id1625644596');
        } else {
          this.openLinkApp('https://play.google.com/store/apps/details?id=com.mycheftool.kds');
        }
        break;
      case 'order':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLinkApp('https://apps.apple.com/es/app/mct-order/id1626244345');
        } else {
          this.openLinkApp('https://play.google.com/store/apps/details?id=com.mycheftool.orders');
        }
        break;
      case 'pos':
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLinkApp('https://apps.apple.com/es/app/mct-pos/id1628506564');
        } else {
          this.openLinkApp('https://play.google.com/store/apps/details?id=com.mycheftool.tpv');
        }
        break;
      default:
        if (this.globals.so_name == 'ios' || this.globals.browser_name == 'safari') {
          this.openLinkApp('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
        } else {
          this.openLinkApp('https://play.google.com/store/apps/developer?id=MyChefTool');
        }
        break;
    }
  }


  openLinkApp(url) {
    if (this.globals.so_mobile) {
      window.location.assign(url);
    } else {
      window.open(url, '_blank');
    }
  }

  openPlayStore() {
    this.openLinkApp('https://play.google.com/store/apps/developer?id=MyChefTool');
  }

  openAppStore() {
    this.openLinkApp('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
  }

  openYoulend() {
    this.openLinkApp('https://youlend.com/apply/mycheftool/es/welcome');
  }

  // #region PUDU

  async puduGetRobotsInfo() {
    this.robots = [];
    if (this.globals.restaurant.pudu_robots_service_up) {
      this.group_id = await this._puduGetGroupRobots();
      await this._puduGeRobots();
    }
  }

  async _puduGetGroupRobots() {
    const response = await this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robot/groups?device=' + this.globals.restaurant.pudu_robots_sdk_device_id, {}).toPromise();
    return response['data']['robotGroups'][0].id;

  }

  async _puduGeRobots() {
    await this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robots?device=' + this.globals.restaurant.pudu_robots_sdk_device_id + '&group_id=' + this.group_id, {})
      .subscribe(res => {
        for (var robot of res['data']['robots']) {
          this._puduGetRobotInfo(robot);
        }
      });
  }

  async _puduGetRobotInfo(robot) {
    await this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robot/status?device_id=' + this.globals.restaurant.pudu_robots_sdk_device_id + '&robot_id=' + robot.id, {})
      .subscribe(res => {
        robot.robotPower = res['data']['robotPower'];
        robot.chargeStage = res['data']['chargeStage'];
        robot.moveState = res['data']['moveState'];
        this.robots.push(robot);
      });
  }

  puduGetDevices() {
    if (this.globals.restaurant.pudu_robots_ip_sdk != '' && this.globals.restaurant.pudu_robots_port_sdk != '') {
      this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/devices', {})
        .subscribe(res => {
          if (res['data']['devices'].length > 0) {
            this.globals.restaurant.pudu_robots_service_up = true;
            //en el restaurante marcamos que tiene el dispositivo conectado
            this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
              'pudu_robots_service_up': true,
            });
          } else {
            this.globals.restaurant.pudu_robots_service_up = false;
            this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
              'pudu_robots_service_up': false,
            });
          }
        }, error => {
          this.globals.restaurant.pudu_robots_service_up = false;
          let toast = this.toastCtrl.create({
            message: "Hubo un error, comprueba que los datos son correctos o el servidor está activo",
            duration: 3000,
            position: 'bottom'
          });
          toast.present();
        });
    } else {
      let toast = this.toastCtrl.create({
        message: "Configura los datos de conexión",
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  // #region navCtrl

  openPuduRobotsConfig() {
    this.navCtrl.push(ConfigurationPuduRobotsPage);
  }

  openArrosseriaList() {
    this.navCtrl.push(TicketsListArrosseriaPage);
  }

  async openStripePortal() {
    if (this.globals.restaurant.stripe_customer_id != undefined && this.globals.restaurant.stripe_customer_id != '') {
      var portal_url = await this.globals.getStripeCustomerPortal();
      this.openLinkApp(portal_url['customer_portal_url']);
    }
  }

  openZendesk() {
    if (this.globals.connection) {
      //this.navCtrl.push(HelpPage);
      window.open('https://mycheftool.zendesk.com/hc/es', '_blank');
    } else {
      this.globals.launchToastNoConnection();
    }
  }

  toggleInviteForm() {
    this.showInviteForm = !this.showInviteForm;
    const modal = this.modalCtrl.create(ComponentsPopupsInviteFormModalComponent);
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard.ts